import ApiInstance from "./ApiInstance";

export interface CourseSummary {
  slug: string;
  title: string;
  summary: string;
  topic?: string;
  // "open" = vrij toegankelijk; "assignable" = verdiepend traject, inhoud
  // alleen na toewijzing door je psycholoog (API-afgedwongen).
  visibility?: "open" | "assignable";
  moduleCount: number;
  lessonCount: number;
  totalMinutes: number;
}
export interface Scale {
  min: number;
  max: number;
  step?: number;
  minLabel?: string;
  maxLabel?: string;
}
export interface Media { url: string; mediaType: "video" | "audio"; poster?: string; }
export interface Breathing { inhale: number; hold1: number; exhale: number; hold2: number; cycles: number; }
// choice: "kies en ontdek" — single-select; each answer reveals its own
// supportive reflection (never graded).
export interface Choice { label: string; feedback: string; }
export interface Section {
  kind: "text" | "tip" | "exercise" | "media" | "breathing" | "choice";
  heading?: string;
  body: string;
  options?: string[]; // exercise: checkable example suggestions
  scale?: Scale; // exercise: slider for a sentiment/intensity rating
  media?: Media; // media: embedded guided-meditation video/audio
  breathing?: Breathing; // breathing: in-app breathing pacer
  choices?: Choice[]; // choice: answers with per-answer reflection
}
export interface Lesson {
  key: string;
  title: string;
  durationMin?: number;
  sections?: Section[];
  journalPrompt?: string;
}
export interface Module {
  title: string;
  summary?: string;
  lessons: Lesson[];
}
export interface Course {
  slug: string;
  title: string;
  summary: string;
  topic?: string;
  visibility?: "open" | "assignable";
  modules: Module[];
}
export interface Progress {
  completed: string[];
  journal: Record<string, string>;
  checks: Record<string, string[]>;
  scales: Record<string, number>;
  choices: Record<string, string>;
}

class CourseApi {
  async list(): Promise<CourseSummary[]> {
    const { data } = await ApiInstance.getApi().get("/courses");
    return data.courses;
  }
  async get(slug: string): Promise<Course> {
    const { data } = await ApiInstance.getApi().get(`/courses/${slug}`);
    return data;
  }
  async getProgress(slug: string): Promise<Progress> {
    const { data } = await ApiInstance.getApi().get(`/courses/${slug}/progress`);
    return data;
  }
  async putProgress(slug: string, body: Progress): Promise<Progress> {
    const { data } = await ApiInstance.getApi().put(`/courses/${slug}/progress`, body);
    return data;
  }
}

const courseApi = new CourseApi();
export default courseApi;
